import { CardBody, CardHeader, CardHeading, UserUpdateResource } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { EventSpeaker } from "./EventSpeaker";

interface Props {
	speakers: UserUpdateResource[];
}

const StyledCardHeadline = styled(CardHeader)`
	border: none;
`;

const GridCardBody = styled(CardBody)`
	display: grid;
	grid-gap: ${({ theme }) => theme.spacing(5)};
	grid-template-columns: 1fr;

	${({ theme }) => theme.breakpoints.tablet} {
		grid-template-columns: 1fr 1fr;
	}
`;

export const EventSpeakersCard: FC<Props> = ({ speakers }) => {
	const { t } = useTranslation();

	return (
		<div>
			<StyledCardHeadline>
				<CardHeading>{t("Speakers")}</CardHeading>
			</StyledCardHeadline>
			<GridCardBody>
				{speakers.map((speaker) => (
					<EventSpeaker key={speaker.id} speaker={speaker} />
				))}
			</GridCardBody>
		</div>
	);
};
